var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT } from "../Infra/i18next";
import { StudyImageSectionName } from "healthex-common/study.dtos";
import { getTranslatedStudyText } from "./TranslationService";
const t = getObservableT("patients");
export class PatientConsentGenericViewModel extends PatientConsentViewModel {
    getTranslatedText(key) {
        if (this.study === NOT_LOADED || this.study === null)
            return "";
        return getTranslatedStudyText(this.study, key, this.patientConsentUIManager.currentLanguage) || "";
    }
    get pageInfo() {
        const study = this.study;
        if (study === NOT_LOADED)
            return NOT_LOADED;
        if (study === null || this.patientConsentUIManager.currentPage === null)
            return { title: null, text: null };
        switch (this.patientConsentUIManager.currentPage) {
            case "ENROLLMENT_PURPOSE_OF_RESEARCH":
                return {
                    title: this.getCustomizedText("purposeOfResearchTitle"),
                    text: this.getTranslatedText("purposeOfResearchText"),
                    images: this.getSectionImages(StudyImageSectionName.PURPOSE_OF_RESEARCH),
                };
            case "ENROLLMENT_PROCEDURES_AND_INTERVENTIONS":
            case "ENROLLMENT_PARTICIPATION_AND_ACTIVITIES":
                return {
                    title: this.getCustomizedText("proceduresAndInterventionsTitle"),
                    text: this.getTranslatedText("proceduresAndInterventionsText"),
                    images: this.getSectionImages(StudyImageSectionName.PROCEDURES_AND_INTERVENTIONS),
                };
            case "ENROLLMENT_CONFIDENTIALITY_OF_DATA":
                return {
                    title: this.getCustomizedText("confidentialityMeasuresTitle"),
                    text: this.getTranslatedText("confidentialityOfDataText"),
                    images: this.getSectionImages(StudyImageSectionName.CONFIDENTIALITY_MEASURES),
                };
            case "ENROLLMENT_INJURY_PROTOCOL":
                return {
                    title: this.getCustomizedText("injuryProtocolTitle"),
                    text: this.getTranslatedText("injuryProtocolText"),
                    images: this.getSectionImages(StudyImageSectionName.INJURY_PROTOCOL),
                };
            case "ENROLLMENT_PARTICIPATION_TERMINATION":
                return {
                    title: this.getCustomizedText("participationTerminationTitle"),
                    text: this.getTranslatedText("participationTerminationText"),
                    images: this.getSectionImages(StudyImageSectionName.PARTICIPATION_TERMINATION),
                };
            case "ENROLLMENT_LEAVING_STUDY_EARLY":
                return {
                    title: this.getCustomizedText("withdrawalImplicationsTitle"),
                    text: this.getTranslatedText("leavingStudyEarlyText"),
                    images: this.getSectionImages(StudyImageSectionName.WITHDRAWAL_IMPLICATIONS),
                };
            case "ENROLLMENT_COST_OF_PARTICIPATION":
                return {
                    title: this.getCustomizedText("costTitle"),
                    text: this.getTranslatedText("costOfParticipationText"),
                    images: this.getSectionImages(StudyImageSectionName.COST_OF_PARTICIPATION),
                };
            case "ENROLLMENT_SHARING_RESULTS":
                return {
                    title: this.getCustomizedText("researchResultsTitle"),
                    text: this.getTranslatedText("sharingResultsText"),
                    images: this.getSectionImages(StudyImageSectionName.RESEARCH_RESULTS),
                };
            case "ENROLLMENT_PATIENT_COMPENSATION":
                return {
                    title: this.getCustomizedText("compensationTitle"),
                    text: this.getTranslatedText("compensationText"),
                    images: this.getSectionImages(StudyImageSectionName.COMPENSATION),
                };
            default:
                return { title: null, text: null };
        }
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentGenericViewModel.prototype, "pageInfo", null);
